import { render, staticRenderFns } from "./Vacancy.vue?vue&type=template&id=8b5556ae&scoped=true&"
import script from "./Vacancy.vue?vue&type=script&lang=js&"
export * from "./Vacancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5556ae",
  null
  
)

export default component.exports